import { render } from "./LoadMore.vue?vue&type=template&id=5ae648ea&scoped=true&ts=true"
import script from "./LoadMore.vue?vue&type=script&lang=ts"
export * from "./LoadMore.vue?vue&type=script&lang=ts"

import "./LoadMore.vue?vue&type=style&index=0&id=5ae648ea&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae648ea"]])

export default __exports__